module.exports = __webpack_public_path__ + "static/media/View_Project.bedb5bdd.svg";